import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProfileCircleLine = () => /*#__PURE__*/_jsx("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M10.75 20.75C13.35 20.75 15.71 19.76 17.49 18.13C17.39 17.19 16.79 16.27 15.72 15.55C13 13.73 8.52 13.73 5.78 15.55C4.71 16.27 4.11 17.19 4.01 18.13C5.79 19.76 8.15 20.75 10.75 20.75ZM10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75C5.22715 0.75 0.75 5.22715 0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75ZM10.8697 11.53C10.7997 11.52 10.7097 11.52 10.6297 11.53C8.86973 11.47 7.46973 10.03 7.46973 8.25998C7.46973 6.44998 8.92973 4.97998 10.7497 4.97998C12.5597 4.97998 14.0297 6.44998 14.0297 8.25998C14.0197 10.03 12.6297 11.47 10.8697 11.53Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});